import React from 'react'
import { components } from 'react-select'

import * as S from './styles'

import { ReactComponent as CheckMark } from '../../../../../assets/svgs/checkmark.svg'

import type { BaseOptionType } from '../types'
import type { OptionProps } from 'react-select'

export const Option = <T extends unknown>(
  props: OptionProps<BaseOptionType<T>>
) => {
  const { isSelected, isMulti, label } = props
  return (
    <components.Option {...props}>
      <S.OptionContainer title={label}>
        <S.OptionLabel $isSelected={isSelected} $isMulti={isMulti}>
          {label}
        </S.OptionLabel>
        {isSelected && isMulti && <CheckMark height={10} width={10} />}
      </S.OptionContainer>
    </components.Option>
  )
}
